import { render } from "./attachmentComp.vue?vue&type=template&id=763a511c"
import script from "./attachmentComp.vue?vue&type=script&lang=js"
export * from "./attachmentComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__